"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React, { useState } from "react";
import Image from "next/image";
import { motion, AnimatePresence } from "framer-motion";
import { brokerageFeatures } from "./brokerage.data";
import { Check } from "lucide-react";
const ease = [0.17, 0.85, 0.438, 0.99] as const;

/* Transparent placeholder so a missing file doesn't show a broken-image icon. */
const PLACEHOLDER = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='540' height='560'%3E%3Crect width='540' height='560' fill='none'/%3E%3C/svg%3E";
const GreenCheck = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-[#44A3D9]"><Check className="h-4 w-4 text-white" strokeWidth={3.5} aria-hidden={true} /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default function SoftwareFeatures() {
  const $ = _c(75);
  const desktopAnimations = useDesktopAnimations();
  const [activeId, setActiveId] = useState(brokerageFeatures[0].id);
  let T0;
  let T1;
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== activeId || $[1] !== desktopAnimations) {
    const active = brokerageFeatures.find(f => f.id === activeId) ?? brokerageFeatures[0];
    const imageRight = active.imageSide === "right";
    t16 = "overflow-hidden bg-white px-6 py-16 font-sans md:py-24 dark:bg-gray-900";
    t13 = "mx-auto w-full max-w-7xl";
    let t17;
    if ($[21] !== desktopAnimations) {
      t17 = desktopAnimations ? {
        opacity: 0,
        y: 40
      } : false;
      $[21] = desktopAnimations;
      $[22] = t17;
    } else {
      t17 = $[22];
    }
    let t18;
    if ($[23] !== desktopAnimations) {
      t18 = desktopAnimations ? {
        opacity: 1,
        y: 0
      } : undefined;
      $[23] = desktopAnimations;
      $[24] = t18;
    } else {
      t18 = $[24];
    }
    let t19;
    if ($[25] !== desktopAnimations) {
      t19 = desktopAnimations ? undefined : {
        opacity: 1,
        y: 0
      };
      $[25] = desktopAnimations;
      $[26] = t19;
    } else {
      t19 = $[26];
    }
    let t20;
    let t21;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = {
        duration: 0.6,
        ease
      };
      t21 = {
        once: true
      };
      $[27] = t20;
      $[28] = t21;
    } else {
      t20 = $[27];
      t21 = $[28];
    }
    let t22;
    if ($[29] !== t17 || $[30] !== t18 || $[31] !== t19) {
      t22 = <motion.h2 initial={t17} whileInView={t18} animate={t19} transition={t20} viewport={t21} className="font-poppins mb-5 text-[1.9rem] font-bold leading-tight text-[#0b1354] sm:text-[2.25rem] lg:text-[2.6rem] dark:text-white">Features of B2B Order Management Software</motion.h2>;
      $[29] = t17;
      $[30] = t18;
      $[31] = t19;
      $[32] = t22;
    } else {
      t22 = $[32];
    }
    let t23;
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t23 = <p className="text-base leading-[1.75] text-[#5b6b7d] dark:text-gray-400">Unlock valuable, data-driven insights into global talent markets.</p>;
      $[33] = t23;
    } else {
      t23 = $[33];
    }
    if ($[34] !== t22) {
      t14 = <div className="mx-auto mb-9 max-w-3xl text-center">{t22}{t23}</div>;
      $[34] = t22;
      $[35] = t14;
    } else {
      t14 = $[35];
    }
    let t24;
    if ($[36] !== activeId) {
      t24 = brokerageFeatures.map(feature => {
        const isActive = feature.id === activeId;
        return <button key={feature.id} type="button" onClick={() => setActiveId(feature.id)} aria-pressed={isActive} className={`cursor-pointer rounded-full border px-6 py-2.5 text-[15px] transition-all duration-300 ${isActive ? "border-transparent bg-[#00a6f0] text-white shadow-[0_8px_20px_-8px_rgba(0,166,240,0.7)]" : "border-[#e6e9f0] bg-white text-[#5b6b7d] hover:border-[#00a6f0] hover:text-[#0b1354] dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300 dark:hover:text-white"}`}>{feature.navLabel}</button>;
      });
      $[36] = activeId;
      $[37] = t24;
    } else {
      t24 = $[37];
    }
    if ($[38] !== t24) {
      t15 = <div className="mb-14 flex flex-wrap items-center justify-center gap-3">{t24}</div>;
      $[38] = t24;
      $[39] = t15;
    } else {
      t15 = $[39];
    }
    T1 = AnimatePresence;
    t12 = "wait";
    T0 = motion.div;
    t5 = active.id;
    if ($[40] !== desktopAnimations) {
      t6 = desktopAnimations ? {
        opacity: 0,
        y: 20
      } : false;
      $[40] = desktopAnimations;
      $[41] = t6;
    } else {
      t6 = $[41];
    }
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = {
        opacity: 1,
        y: 0
      };
      t8 = {
        opacity: 0,
        y: 10
      };
      t9 = {
        duration: 0.35,
        ease
      };
      $[42] = t7;
      $[43] = t8;
      $[44] = t9;
    } else {
      t7 = $[42];
      t8 = $[43];
      t9 = $[44];
    }
    t10 = "grid grid-cols-1 items-center gap-14 lg:grid-cols-2 lg:gap-16";
    t11 = <div className={`flex items-center justify-center ${imageRight ? "order-1 lg:order-2" : "order-1"}`}><Image src={active.image} alt={active.alt} width={540} height={560} loading="lazy" className="w-full max-w-[540px] object-contain" onError={_temp} /></div>;
    t2 = `flex flex-col justify-center ${imageRight ? "order-2 lg:order-1" : "order-2"}`;
    t3 = <h3 className="font-poppins mb-5 text-[1.75rem] font-bold leading-tight text-[#0b1354] sm:text-[2.1rem] lg:text-[2.6rem] dark:text-white">{active.heading}</h3>;
    t4 = <p className="mb-9 max-w-xl text-base leading-[1.75] text-[#5b6b7d] lg:text-[17px] dark:text-gray-300">{active.description}</p>;
    t0 = "grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2";
    t1 = active.points.map(_temp2);
    $[0] = activeId;
    $[1] = desktopAnimations;
    $[2] = T0;
    $[3] = T1;
    $[4] = t0;
    $[5] = t1;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t13;
    $[10] = t14;
    $[11] = t15;
    $[12] = t16;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    T0 = $[2];
    T1 = $[3];
    t0 = $[4];
    t1 = $[5];
    t10 = $[6];
    t11 = $[7];
    t12 = $[8];
    t13 = $[9];
    t14 = $[10];
    t15 = $[11];
    t16 = $[12];
    t2 = $[13];
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
    t7 = $[18];
    t8 = $[19];
    t9 = $[20];
  }
  let t17;
  if ($[45] !== t0 || $[46] !== t1) {
    t17 = <ul className={t0}>{t1}</ul>;
    $[45] = t0;
    $[46] = t1;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t17 || $[49] !== t2 || $[50] !== t3 || $[51] !== t4) {
    t18 = <div className={t2}>{t3}{t4}{t17}</div>;
    $[48] = t17;
    $[49] = t2;
    $[50] = t3;
    $[51] = t4;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  let t19;
  if ($[53] !== T0 || $[54] !== t10 || $[55] !== t11 || $[56] !== t18 || $[57] !== t5 || $[58] !== t6 || $[59] !== t7 || $[60] !== t8 || $[61] !== t9) {
    t19 = <T0 key={t5} initial={t6} animate={t7} exit={t8} transition={t9} className={t10}>{t11}{t18}</T0>;
    $[53] = T0;
    $[54] = t10;
    $[55] = t11;
    $[56] = t18;
    $[57] = t5;
    $[58] = t6;
    $[59] = t7;
    $[60] = t8;
    $[61] = t9;
    $[62] = t19;
  } else {
    t19 = $[62];
  }
  let t20;
  if ($[63] !== T1 || $[64] !== t12 || $[65] !== t19) {
    t20 = <T1 mode={t12}>{t19}</T1>;
    $[63] = T1;
    $[64] = t12;
    $[65] = t19;
    $[66] = t20;
  } else {
    t20 = $[66];
  }
  let t21;
  if ($[67] !== t13 || $[68] !== t14 || $[69] !== t15 || $[70] !== t20) {
    t21 = <div className={t13}>{t14}{t15}{t20}</div>;
    $[67] = t13;
    $[68] = t14;
    $[69] = t15;
    $[70] = t20;
    $[71] = t21;
  } else {
    t21 = $[71];
  }
  let t22;
  if ($[72] !== t16 || $[73] !== t21) {
    t22 = <section className={t16}>{t21}</section>;
    $[72] = t16;
    $[73] = t21;
    $[74] = t22;
  } else {
    t22 = $[74];
  }
  return t22;
}
function _temp2(point) {
  return <li key={point} className="flex items-start gap-3.5"><GreenCheck /><span className="font-poppins text-[17px] font-bold leading-snug text-[#0b1354] dark:text-white">{point}</span></li>;
}
function _temp(e) {
  e.currentTarget.onerror = null;
  e.currentTarget.src = PLACEHOLDER;
}